export default __webpack_public_path__ + "static/Custom_apss1-271d159c0222842d5fbb065783cd4a38.jpg";